<template>
  <div class="row__times">
    <slot />
    <div class="time" v-for="(time, key) in times" :key="key">
      <span v-if="isHead">{{ time }}</span>
    </div>
  </div>
</template>

<script>
export default {
    name: 'calendar-day-item-time',
    props: {
        times: {
            required: false,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: [
                '00:00',
                '01:00',
                '02:00',
                '03:00',
                '04:00',
                '05:00',
                '06:00',
                '07:00',
                '08:00',
                '09:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
            ],
            type: Array,
        },
        isHead: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
// @import "src/assets/sass/main";

// .row {
//   &__times {
//     position: relative;
//     width: 100%;
//     display: flex;

//     & .time {
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       width: calc(100% / 10);
//       color: rgba(#4d4d4d, 0.5);
//       font-family: $fontMedium;
//       font-size: 16px;
//       box-sizing: border-box;
//       min-width: 45px;
//       position: relative;

//       &::before {
//         position: absolute;
//         content: "";
//         border-left: 1px solid rgba(77, 77, 77, 0.3);
//         z-index: 5;
//         height: 100%;
//         left: 0;
//         width: 2px;
//       }

//       @include respond(desktop) {
//         min-width: 39px;
//         font-size: 13px;
//       }

//       &:last-child {
//         &::after {
//           position: absolute;
//           content: "";
//           // border-right: 1px solid rgba(77, 77, 77, 0.5);
//           z-index: 5;
//           height: 100%;
//           right: 0;
//           width: 2px;
//         }
//       }
//     }
//   }

//   &--new {
//     cursor: pointer;

//     & .row__name {
//       justify-content: flex-start;
//       border-top: 1px solid #71bd4a;
//       padding-left: 16px;
//       box-sizing: border-box;
//       color: #4d4d4d;
//       font-size: 10px;

//       & img {
//         margin-right: 10px;
//         width: 24px;
//       }
//     }

//     & .time span {
//       display: block;
//       width: 100%;
//       height: 100%;
//       background-color: rgba(#71bd4a, 0.1);
//     }

//     & .request {
//       position: absolute;
//       top: 9px;
//       height: 30px;
//       border-radius: 8px;
//       box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//       background-color: #71bd4a;
//       color: #ffffff;
//       font-size: 12px;
//       font-family: $fontBold;
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       text-align: center;
//       width: 40px;
//     }
//   }
// }
</style>
